import React, { useState } from 'react';
import { Container, Col, Row, ModalBody, Modal } from 'reactstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import closeImg from '../../assets/img/close.png';
import viewDocImg from '../../images/viewDoc.png';
import './index.css';
import Storage from '../../services/Storage';
import DateService from '../../services/DateService';
import UploadDocPreview from '../CustomModal/UploadDocPreview/UploadDocPreview';
import { Roles } from '../../constants/Roles';
import { CommonButton } from '../CommonComponents';
import ConfirmChequeModal from '../CustomModal/AcceptMultipleOrderConfirmModal/ConfirmChequeModal';

const AdvanceBusinessInfo = ({ previewData, userId,submitConfirmCheque=async ()=>{} }) => {
  let userInfo = Storage.getUserInfoDetail();
  let roleId = userInfo ? userInfo.id : null;
  let roleName = userInfo ? userInfo.role : '';

  const [modal, setModal] = useState(false);
  const [popupImgPreview, setPopupImgPreview] = useState('');
  const [title, setTitle] = useState('');
  const [isOpenConfirmCheque,setIsOpenConfirmCheque]=useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const setBreadcrumbsRecord = () => {
    if (previewData.business_name) {
      Storage.setBreadcrumbsrRecord([
        {
          title: 'Preview App',
          url: location.pathname,
        },
        {
          title: previewData.business_name,
          url: `/pages/new-dealer/${previewData.id}`,
        },
      ]);
    }
  };

  const toggle = (val, title, key) => {
    if (key) {
      setPopupImgPreview(val);
      setTitle(title);
    }
    setModal(!modal);
  };
  
  return (
    <div id="advanceBusinessInfo">
      <div className="bankinfo">
        <Row>
          <Col xs={12}>
            <div className="main-title">
              Advance Business Information
              {roleName &&
              (roleName === Roles.TM_NAME ||
                roleName === Roles.BH_NAME ||
                (roleName === Roles.SH_NAME &&
                  previewData.created_by &&
                  previewData.created_by === roleId)) ? (
                <i
                  onClick={() => {
                    setBreadcrumbsRecord();
                    navigate(
                      `/pages/advance-business-details/${
                        Storage.getAddNewDealerId()
                          ? Storage.getAddNewDealerId()
                          : userId
                      }`,
                    );
                  }}
                  className="fa fa-edit editButton noprint"
                ></i>
              ) : (
                ''
              )}
            </div>
          </Col>
          <Col xs={12}>
            <div className="common-title">Bank Details</div>
          </Col>
          <Col xs={12} className="mb-2">
            <div className="infodatablock">
              {previewData.account_number && (
                <div className="info">
                  <div className="common-heading">Current A/C No.</div>
                  <div className="subData">{previewData.account_number}</div>
                </div>
              )}
              {previewData.ifsc_code && (
                <div className="info">
                  <div className="common-heading">NEFT/RTGS Code</div>
                  <div className="subData">{previewData.ifsc_code}</div>
                </div>
              )}
              {previewData.bank_name && (
                <div className="info">
                  <div className="common-heading">Bank Name</div>
                  <div className="subData">{previewData.bank_name}</div>
                </div>
              )}
              {previewData.branch_name && (
                <div className="info">
                  <div className="common-heading">Branch Name</div>
                  <div className="subData">{previewData.branch_name}</div>
                </div>
              )}
              {previewData.sigining_authority_person_name && (
                <div className="info">
                  <div className="common-heading">Signing Authority</div>
                  <div className="subData">
                    {previewData.sigining_authority_person_name}
                  </div>
                </div>
              )}
              {previewData.bank_limit && (
                <div className="info">
                  <div className="common-heading">CC Limit of Bank</div>
                  <div className="subData">{previewData.bank_limit}</div>
                </div>
              )}
              {previewData.bank_address && (
                <div className="info">
                  <div className="common-heading">Branch Address</div>
                  <div className="subData">{previewData.bank_address}</div>
                </div>
              )}
            </div>
          </Col>
        </Row>
      </div>
      <div className="bankinfo securityDepoBlock">
        <Row>
          <Col xs={12}>
            <div className="common-title">Security Deposit</div>
          </Col>
          <Col xs={12} className="mb-2">
            <div className="infodatablock">
              {previewData.security_deposit_flag === 'Applicable' ? (
                <>
                  <div className="info">
                    <div className="common-heading d-flex">
                      <input type="radio" checked className="mr-2" />
                      Applicable
                    </div>
                  </div>
                  <div className="info">
                    <div className="common-heading">Amount</div>
                    <div className="subData">
                      {previewData.security_deposit}
                    </div>
                  </div>
                  <div className="info">
                    <div className="common-heading">Mode of Payment</div>
                    <div className="subData">{previewData.payment_mode}</div>
                  </div>
                  {previewData.payment_mode === 'Cheque' && (
                    <>
                      {' '}
                      <div className="info">
                        <div className="common-heading">Bank Name</div>
                        <div className="subData">
                          {previewData.cheque_bank_name}
                        </div>
                      </div>
                      <div className="info">
                        <div className="common-heading">Cheque No.</div>
                        <div className="subData">
                          {previewData.cheque_number}
                        </div>
                      </div>
                      <div className="info">
                        <div className="common-heading">Cheque date</div>
                        <div className="subData">
                          {DateService.utcToLocalDateOnly(
                            previewData.cheque_date,
                          ) || 'N/A'}
                        </div>
                      </div>
                      <div className="info">
                        <div
                          className="infoInner d-flex"
                          style={{
                            border: '1px solid #e3e3e3',
                            padding: '5px 10px',
                            marginTop: '-5px',
                            borderRadius: '5px',
                          }}
                        >
                          <div className="common-heading">Cheque Image</div>
                          <div className="infoView text-center ml-3">
                            <img
                              src={viewDocImg}
                              className="fileIcon noprint"
                              alt="view"
                            ></img>
                            <div
                              className="viewText noprint"
                              onClick={() => {
                                if (previewData.cheque_image.includes('.pdf')) {
                                  window.open(
                                    previewData.cheque_image,
                                    '_blank',
                                  );
                                } else {
                                  toggle(
                                    previewData.cheque_image,
                                    'Cheque Image',
                                    8,
                                  );
                                }
                              }}
                            >
                              view
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  {previewData.payment_mode === 'NEFT/RTGS' && (
                    <>
                      {' '}
                      <div className="info">
                        <div className="common-heading">
                          NEFT/RTGS Reference No.
                        </div>
                        <div className="subData">
                          {previewData.neft_rtgs_ref_number}
                        </div>
                      </div>
                      <div className="info">
                        <div className="common-heading">Date</div>
                        <div className="subData">
                          {DateService.utcToLocalDateOnly(
                            previewData.neft_rtgs_date,
                          ) || 'N/A'}
                        </div>
                      </div>
                      <div className="info">
                        <div
                          className="infoInner d-flex"
                          style={{
                            border: '1px solid #e3e3e3',
                            padding: '5px 10px',
                            marginTop: '-5px',
                            borderRadius: '5px',
                          }}
                        >
                          <div className="common-heading">
                            NEFT/RTGS Reciept
                          </div>
                          {/* <div className='infoView text-center ml-3'>
                          <img
                            src={viewDocImg}
                            className='fileIcon noprint'
                            alt='view'
                          ></img>
                          <div
                            className='viewText noprint'
                            onClick={() =>
                              toggle(
                                previewData.neft_rtgs_reciept,
                                'NEFT/RTGS Reciept',
                                8
                              )
                            }
                          >
                            view
                          </div>
                        </div> */}
                          {previewData.neft_rtgs_reciept && (
                            <div className="infoView text-center ml-3">
                              <img
                                src={viewDocImg}
                                className="fileIcon noprint"
                                alt="view"
                              ></img>
                              <div
                                className="viewText noprint"
                                onClick={() => {
                                  if (
                                    previewData.neft_rtgs_reciept.includes(
                                      '.pdf',
                                    )
                                  ) {
                                    window.open(
                                      previewData.neft_rtgs_reciept,
                                      '_blank',
                                    );
                                  } else {
                                    toggle(
                                      previewData.neft_rtgs_reciept,
                                      'NEFT/RTGS Reciept',
                                      8,
                                    );
                                  }
                                }}
                              >
                                view
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                </>
              ) : previewData.security_deposit_flag === 'Non Applicable' ? (
                <div className="info">
                  <div className="common-heading d-flex">
                    <input type="radio" checked className="mr-2" />
                    Not Applicable
                  </div>
                </div>
              ) : (
                ''
              )}
            </div>
          </Col>
        </Row>
      </div>
      <div className="documentBlock">
        <Row>
          <Col xs={12}>
            <div className="common-title">Additional Security Cheque</div>
          </Col>
          <Col xs={12} className="mb-2">
            <div className="infodatablock">
              <Row>
                {previewData.security_bank_name && (
                  <Col lg={2} md={4} sm={6}>
                    <div className="info flex-column border-0">
                      <div className="common-heading">Bank Name</div>
                      <div className="subData">
                        {previewData.security_bank_name}
                      </div>
                    </div>
                  </Col>
                )}
                {(previewData.cheque_number_1 ||
                  previewData.cheque_1_image) && (
                  <Col lg={3} md={4} sm={6}>
                    <div className="info">
                      <div className="infoInner">
                        <div className="common-heading">Cheque 1 Number</div>
                        <div className="subData">
                          {previewData.cheque_number_1}
                        </div>
                      </div>
                      {previewData.cheque_1_image && (
                        <div className="infoView text-center">
                          <img
                            src={viewDocImg}
                            className="fileIcon noprint"
                            alt="view"
                          ></img>
                          <div
                            className="viewText noprint"
                            onClick={() => {
                              if (previewData.cheque_1_image.includes('.pdf')) {
                                window.open(
                                  previewData.cheque_1_image,
                                  '_blank',
                                );
                              } else {
                                toggle(
                                  previewData.cheque_1_image,
                                  'Cheque 1',
                                  10,
                                );
                              }
                            }}
                          >
                            view
                          </div>
                        </div>
                      )}
                    </div>
                  </Col>
                )}
                {(previewData.cheque_number_2 ||
                  previewData.cheque_2_image) && (
                  <Col lg={3} md={4} sm={6}>
                    <div className="info">
                      <div className="infoInner">
                        <div className="common-heading">Cheque 2 Number</div>
                        <div className="subData">
                          {previewData.cheque_number_2}
                        </div>
                      </div>
                      {previewData.cheque_2_image && (
                        <div className="infoView text-center">
                          <img
                            src={viewDocImg}
                            className="fileIcon noprint"
                            alt="view"
                          ></img>
                          <div
                            className="viewText noprint"
                            onClick={() => {
                              if (previewData.cheque_2_image.includes('.pdf')) {
                                window.open(
                                  previewData.cheque_2_image,
                                  '_blank',
                                );
                              } else {
                                toggle(
                                  previewData.cheque_2_image,
                                  'Cheque 2',
                                  10,
                                );
                              }
                            }}
                          >
                            view
                          </div>
                        </div>
                      )}
                    </div>
                  </Col>
                )}
                <Col lg={3} md={4} sm={6}>
                {roleName === Roles.CNF_ROLE && !previewData?.is_confirm_cheques &&
                          <CommonButton name={'Verify Cheque'} btnClass={'btnPrimary'} type="button" onClick={()=>{
                            setIsOpenConfirmCheque(true);
                          }} />
                        }
                  </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </div>
      <div className="documentBlock">
        <Row>
          <Col xs={12}>
            <div className="common-title">Documents</div>
          </Col>
          <Col xs={12} className="mb-2">
            <div className="infodatablock">
              <Row>
                {(previewData.shop_act_no || previewData.shop_act_no_file) && (
                  <Col lg={3} md={4} sm={6}>
                    <div className="info">
                      <div className="infoInner">
                        <div className="common-heading">Shop Act No.</div>
                        <div className="subData">{previewData.shop_act_no}</div>
                      </div>
                      {previewData.shop_act_no_file && (
                        <div className="infoView text-center">
                          <img
                            src={viewDocImg}
                            className="fileIcon noprint"
                            alt="view"
                          ></img>
                          <div
                            className="viewText noprint"
                            onClick={() => {
                              if (
                                previewData.shop_act_no_file.includes('.pdf')
                              ) {
                                window.open(
                                  previewData.shop_act_no_file,
                                  '_blank',
                                );
                              } else {
                                toggle(
                                  previewData.shop_act_no_file,
                                  'Shop A/C No. File',
                                  8,
                                );
                              }
                            }}
                          >
                            view
                          </div>
                        </div>
                      )}
                    </div>
                  </Col>
                )}
                {(previewData.gst_no || previewData.gst_no_file) && (
                  <Col lg={3} md={4} sm={6}>
                    <div className="info">
                      <div className="infoInner">
                        <div className="common-heading">Gst No.</div>
                        <div className="subData">{previewData.gst_no}</div>
                      </div>
                      {previewData.gst_no_file && (
                        <div className="infoView text-center">
                          <img
                            src={viewDocImg}
                            className="fileIcon noprint"
                            alt="view"
                          ></img>
                          <div
                            className="viewText noprint"
                            onClick={() => {
                              if (previewData.gst_no_file.includes('.pdf')) {
                                window.open(previewData.gst_no_file, '_blank');
                              } else {
                                toggle(
                                  previewData.gst_no_file,
                                  'Gst No. File',
                                  7,
                                );
                              }
                            }}
                          >
                            view
                          </div>
                        </div>
                      )}
                    </div>
                  </Col>
                )}
                {(previewData.pan_no || previewData.firm_pan_no) && (
                  <Col lg={3} md={4} sm={6}>
                    <div className="info">
                      <div className="infoInner">
                        <div className="common-heading">PAN no. of Firm</div>
                        <div className="subData">{previewData.firm_pan_no}</div>
                      </div>
                      {previewData.firm_pan_file && (
                        <div className="infoView text-center">
                          <img
                            src={viewDocImg}
                            className="fileIcon noprint"
                            alt="view"
                          ></img>
                          <div
                            className="viewText noprint"
                            onClick={() => {
                              if (previewData.firm_pan_file.includes('.pdf')) {
                                window.open(
                                  previewData.firm_pan_file,
                                  '_blank',
                                );
                              } else {
                                toggle(
                                  previewData.firm_pan_file,
                                  'PAN no. of Firm File',
                                  5,
                                );
                              }
                            }}
                          >
                            view
                          </div>
                        </div>
                      )}
                    </div>
                  </Col>
                )}
                {(previewData.aadhar_no || previewData.aadhar_no_file) && (
                  <Col lg={3} md={4} sm={6}>
                    <div className="info">
                      <div className="infoInner">
                        <div className="common-heading">Owner’s Aadhar No.</div>
                        <div className="subData">{previewData.aadhar_no}</div>
                      </div>
                      {previewData.aadhar_no_file && (
                        <div className="infoView text-center">
                          <img
                            src={viewDocImg}
                            className="fileIcon noprint"
                            alt="view"
                          ></img>
                          <div
                            className="viewText noprint"
                            onClick={() => {
                              if (previewData.aadhar_no_file.includes('.pdf')) {
                                window.open(
                                  previewData.aadhar_no_file,
                                  '_blank',
                                );
                              } else {
                                toggle(
                                  previewData.aadhar_no_file,
                                  'Adhar No. File',
                                  4,
                                );
                              }
                            }}
                          >
                            view
                          </div>
                        </div>
                      )}
                    </div>
                  </Col>
                )}
                {(previewData.pan_no || previewData.pan_no_file) && (
                  <Col lg={3} md={4} sm={6}>
                    <div className="info">
                      <div className="infoInner">
                        <div className="common-heading">Owner’s PAN No.</div>
                        <div className="subData">{previewData.pan_no}</div>
                      </div>
                      {previewData.pan_no_file && (
                        <div className="infoView text-center">
                          <img
                            src={viewDocImg}
                            className="fileIcon noprint"
                            alt="view"
                          ></img>
                          <div
                            className="viewText noprint"
                            onClick={() => {
                              if (previewData.pan_no_file.includes('.pdf')) {
                                window.open(previewData.pan_no_file, '_blank');
                              } else {
                                toggle(
                                  previewData.pan_no_file,
                                  'PAN No. of Proprietor/Partner File',
                                  4,
                                );
                              }
                            }}
                          >
                            view
                          </div>
                        </div>
                      )}
                    </div>
                  </Col>
                )}
                {(previewData.fertilizer_lic_no ||
                  previewData.fertilizer_lic_valid_date ||
                  previewData.fertilizer_lic_no_file) && (
                  <Col lg={3} md={4} sm={6}>
                    <div className="info">
                      <div className="infoInner">
                        <div className="common-heading">
                          Fertilizer Lic. No.
                        </div>
                        <div className="subData">
                          {previewData.fertilizer_lic_no}
                        </div>
                        <div className="subData">
                          {previewData.fertilizer_lic_valid_date !== null
                            ? `validity : ${DateService.utcToLocalDateOnly(
                                previewData.fertilizer_lic_valid_date,
                              ) || 'N/A'}`
                            : ''}
                        </div>
                      </div>
                      {previewData.fertilizer_lic_no_file && (
                        <div className="infoView text-center">
                          <img
                            src={viewDocImg}
                            className="fileIcon noprint"
                            alt="view"
                          ></img>
                          <div
                            className="viewText noprint"
                            onClick={() => {
                              if (
                                previewData.fertilizer_lic_no_file.includes(
                                  '.pdf',
                                )
                              ) {
                                window.open(
                                  previewData.fertilizer_lic_no_file,
                                  '_blank',
                                );
                              } else {
                                toggle(
                                  previewData.fertilizer_lic_no_file,
                                  'Fertilizer  Lic. No File',
                                  6,
                                );
                              }
                            }}
                          >
                            view
                          </div>
                        </div>
                      )}
                    </div>
                  </Col>
                )}
                {(previewData.pesticides_lic_no ||
                  previewData.pesticides_lic_valid_date ||
                  previewData.pesticides_lic_no_file) && (
                  <Col lg={3} md={4} sm={6}>
                    <div className="info">
                      <div className="infoInner">
                        <div className="common-heading">
                          Pesticides Lic. No.
                        </div>
                        <div className="subData">
                          {previewData.pesticides_lic_no}
                        </div>
                        <div className="subData">
                          {previewData.pesticides_lic_valid_date !== null
                            ? `validity : ${DateService.utcToLocalDateOnly(
                                previewData.pesticides_lic_valid_date,
                              ) || 'N/A'}`
                            : ''}
                        </div>
                      </div>
                      {previewData.pesticides_lic_no_file && (
                        <div className="infoView text-center">
                          <img
                            src={viewDocImg}
                            className="fileIcon noprint"
                            alt="view"
                          ></img>
                          <div
                            className="viewText noprint"
                            onClick={() => {
                              if (
                                previewData.pesticides_lic_no_file.includes(
                                  '.pdf',
                                )
                              ) {
                                window.open(
                                  previewData.pesticides_lic_no_file,
                                  '_blank',
                                );
                              } else {
                                toggle(
                                  previewData.pesticides_lic_no_file,
                                  'Pesticides Lic. No. File',
                                  2,
                                );
                              }
                            }}
                          >
                            view
                          </div>
                        </div>
                      )}
                    </div>
                  </Col>
                )}
                {previewData.file_upload_flag === 'lastSixMonthBankStmnt' ? (
                  <Col lg={3} md={4} sm={6}>
                    <div className="info">
                      <div className="infoInner">
                        <div className="common-heading">
                          Upload Last 6 months Bank Statement
                        </div>
                        <div className="subData"></div>
                      </div>
                      <div className="infoView text-center">
                        <img
                          src={viewDocImg}
                          className="fileIcon noprint"
                          alt="view"
                        ></img>
                        <div
                          className="viewText noprint"
                          onClick={() => {
                            if (
                              previewData.last_six_month_bank_statement.includes(
                                '.pdf',
                              )
                            ) {
                              window.open(
                                previewData.last_six_month_bank_statement,
                                '_blank',
                              );
                            } else {
                              toggle(
                                previewData.last_six_month_bank_statement,
                                'Upload Last 6 months Bank Statement',
                                2,
                              );
                            }
                          }}
                        >
                          view
                        </div>
                      </div>
                    </div>
                  </Col>
                ) : (
                  ''
                )}
                {previewData.file_upload_flag === 'lastYearItReturn' ? (
                  <Col lg={3} md={4} sm={6}>
                    <div className="info">
                      <div className="infoInner">
                        <div className="common-heading">
                          Upload Last Financial Year It Returns
                        </div>
                        <div className="subData"></div>
                      </div>
                      <div className="infoView text-center">
                        <img
                          src={viewDocImg}
                          className="fileIcon noprint"
                          alt="view"
                        ></img>
                        <div
                          className="viewText noprint"
                          onClick={() => {
                            if (previewData.it_return_file.includes('.pdf')) {
                              window.open(previewData.it_return_file, '_blank');
                            } else {
                              toggle(
                                previewData.it_return_file,
                                'Upload Last Financial Year It Returns',
                                2,
                              );
                            }
                          }}
                        >
                          view
                        </div>
                      </div>
                    </div>
                  </Col>
                ) : (
                  ''
                )}
                {(previewData.business_type === 'Partnership Firm' ||
                  previewData.business_type === 'Pvt.ltd.' ||
                  previewData.business_type === 'Ltd.') &&
                  previewData.partnership_deed_file && (
                    <Col lg={3} md={4} sm={6}>
                      <div className="info">
                        <div className="infoInner">
                          <div className="common-heading">
                            {previewData.business_type === 'Partnership Firm'
                              ? 'Partnership Deed'
                              : 'Upload M&A Copy'}
                          </div>
                          <div className="subData">&nbsp;</div>
                        </div>
                        <div className="infoView text-center">
                          <img
                            src={viewDocImg}
                            className="fileIcon noprint"
                            alt="view"
                          ></img>
                          <div
                            className="viewText noprint"
                            onClick={() => {
                              if (
                                previewData.partnership_deed_file.includes(
                                  '.pdf',
                                )
                              ) {
                                window.open(
                                  previewData.partnership_deed_file,
                                  '_blank',
                                );
                              } else {
                                toggle(
                                  previewData.partnership_deed_file,
                                  previewData.business_type ===
                                    'Partnership Firm'
                                    ? 'Partnership Deed'
                                    : 'Upload M&A Copy',
                                  3,
                                );
                              }
                            }}
                          >
                            view
                          </div>
                        </div>
                      </div>
                    </Col>
                  )}
              </Row>
            </div>
          </Col>
        </Row>
      </div>

      {/* Preview Doc Modal */}
      <Modal
        id="previewAppImgModal"
        isOpen={modal}
        toggle={toggle}
        className="uploadDocModal"
        centered
      >
        <ModalBody className="pl-0 pr-0">
          <Container>
            <Row>
              <Col xs={12}>
                <div className="modalHeading">
                  <div className="title leftTitle">{title}</div>
                  <div className="closeButton">
                    <img
                      src={closeImg}
                      alt="close"
                      onClick={() => setModal(!modal)}
                    />
                  </div>
                </div>
              </Col>
              <Col xs={12} className="text-center">
                <UploadDocPreview
                  isRemove={false}
                  uploadDocpath={popupImgPreview}
                  // handleRemoveClick={removeSelectedImage}
                />
              </Col>
            </Row>
          </Container>
        </ModalBody>
      </Modal>
      <ConfirmChequeModal 
      isOpen={isOpenConfirmCheque}
       toggle={()=>{
        setIsOpenConfirmCheque(false)
       }}
       handleSubmit={async ()=>{
        setIsOpenConfirmCheque(false);
        await submitConfirmCheque();
       }}
      />
    </div>
  );
};

export default React.memo(AdvanceBusinessInfo);
